export default __webpack_public_path__ + "static/media/related-post-04.41bb677a.jpg";